import resolveComponent from '../resolveComponent';

/**
 * @example `/${appid}${appAccountManagePrefix}`
 * @example `/:appId${appAccountManagePrefix}`
 *  */
export const appAccountManagePrefix = '/account-manage';
export const appAccountManagePrefixName = '账号管理';

const appAccountManage_list = `${appAccountManagePrefix}/list`;
const appAccountManage_listName = '公众号绑定';

/**
 * @example `/${appid}${appAccountManage_offiaccount_list}`
 * @example `/:appId${appAccountManage_offiaccount_list}`
 *  */
export const appAccountManage_list_list = appAccountManage_list;
export const appAccountManage_list_listName = '公众号绑定';
export const appAccountManage_list_listAccess = 'ACCOUNT-LIST';

/**
 * @example `/${appid}${appAccountManage_offiaccount_detail}`
 * @example `/:appId${appAccountManage_offiaccount_detail}`
 * 审核失败，重新绑定时，需要加个id
 * @example `/${appid}${appAccountManage_offiaccount_detail}/${errorId}`
 * @example `/:appId${appAccountManage_offiaccount_detail}/:errorId`
 *  */
export const appAccountManage_list_detail = `${appAccountManage_list}/detail`;
export const appAccountManage_list_detailName = '账号绑定';

/**
 * @example `/${appid}${appAccountManage_offiaccount_edit}/${id}`
 * @example `/:appId${appAccountManage_offiaccount_edit}/:id`
 *  */
export const appAccountManage_list_edit = `${appAccountManage_list}/edit`;
export const appAccountManage_list_editName = '编辑';

/**
 * @example `/${appid}${appAccountManage_check}`
 * @example `/:appId${appAccountManage_check}`
 *  */
export const appAccountManage_check = `${appAccountManagePrefix}/check`;
export const appAccountManage_checkName = '公众号审核';

const AccountManageRouteConfig = [
  {
    path: `/:appId?${appAccountManagePrefix}`,
    label: appAccountManagePrefixName,
    exact: false,
    component: resolveComponent(() => import('@src/service')),
    children: [
      {
        path: `/:appId?${appAccountManage_list}`,
        label: appAccountManage_listName,
        code: appAccountManage_list_listAccess,
        exact: false,
        children: [
          {
            path: `/:appId?${appAccountManage_list_detail}/:errorId?`,
            exact: true,
            label: appAccountManage_list_detailName,
            component: resolveComponent(() => import('@src/pages/app/accountManage/list-detail')),
          },
          {
            path: `/:appId?${appAccountManage_list_edit}/:id`,
            exact: true,
            label: appAccountManage_list_editName,
            component: resolveComponent(() => import('@src/pages/app/accountManage/list-detail')),
          },
          {
            path: `/:appId?${appAccountManage_list_list}`,
            exact: true,
            label: '公众号绑定',
            component: resolveComponent(() => import('@src/pages/app/accountManage/list')),
          },
        ],
      },
      {
        path: `/:appId?${appAccountManage_check}`,
        exact: true,
        label: appAccountManage_checkName,
        component: resolveComponent(() => import('@src/pages/app/accountManage/check')),
      },
    ],
  },
];

export default AccountManageRouteConfig;
